import {
  getBoardInventory,
  getConsignmentInventory,
  normalizeLocale,
  MARKET_ON,
} from "@/utils/market-utils";
import { createListingPdfFilters } from "@/utils/listing-pdf-utils";

const copy = {
  fr: {
    about: "À propos",
    company: "Compagnie",
    producers: "Producteurs",
    privacy: "Politique de confidentialité",
    terms: "Politique d'utilisation",
    faq: "FAQ",
    privateImport: "Importation privée",
    consignment: "Consignation",
    restaurantList: "Liste restaurants",
    individualList: "Liste particuliers",
    availableWines: "Vins disponibles",
    upcomingWines: "Vins à venir",
    products: "Produits",
    wines: "Vin",
    ciderBeer: "Cidre & bière",
    spirits: "Spiritueux",
    nonAlcoholic: "Sans alcool",
    boutique: "Boutique",
    getInTouch: "Nous joindre",
    contactUs: "Contactez-nous",
    newsletter: "Infolettre",
    becomeClient: "Devenir client",
  },
  en: {
    about: "About",
    company: "Company",
    producers: "Producers",
    privacy: "Privacy Policy",
    terms: "Terms of Use",
    faq: "FAQ",
    privateImport: "Private Import",
    consignment: "Consignment",
    restaurantList: "Restaurant List",
    individualList: "Private Customer List",
    availableWines: "Available Wines",
    upcomingWines: "Upcoming Wines",
    products: "Products",
    wines: "Wine",
    ciderBeer: "Cider & Beer",
    spirits: "Spirits",
    nonAlcoholic: "Non-Alcoholic",
    boutique: "Shop",
    getInTouch: "Get in Touch",
    contactUs: "Contact Us",
    newsletter: "Newsletter",
    becomeClient: "Become a Client",
  },
};

function createProductRoute(query) {
  return {
    name: "products",
    query: {
      page: 1,
      req: true,
      ...query,
    },
  };
}

export function createFooterNavigation(market, locale) {
  const localeKey = normalizeLocale(locale);
  const labels = copy[localeKey];
  const consignmentInventory = getConsignmentInventory(market);
  const boardInventory = getBoardInventory(market);
  const boutiqueInventory = market === MARKET_ON ? "STORE_TORONTO" : "STORE_MTL";

  return [
    {
      menuHeader: labels.about,
      menuItems: [
        { type: "route", to: "/about-us", label: labels.company },
        {
          type: "route",
          to: {
            name: "providers",
            query: { type: market },
          },
          label: labels.producers,
        },
        { type: "route", to: "/privacy-policy", label: labels.privacy },
        { type: "route", to: "/terms-of-use", label: labels.terms },
        { type: "route", to: "/faq", label: labels.faq },
      ],
    },
    {
      menuHeader: boardInventory,
      menuItems: [
        {
          type: "pdfAction",
          label: labels.restaurantList,
          filters: createListingPdfFilters({
            inventory: boardInventory,
            tax: "OUT",
          }),
        },
        {
          type: "pdfAction",
          label: labels.individualList,
          filters: createListingPdfFilters({
            inventory: boardInventory,
            tax: "IN",
          }),
        },
        {
          type: "route",
          to: createProductRoute({
            inventory: [boardInventory],
            show: "AVAILABLE",
          }),
          label: labels.availableWines,
        },
      ],
    },
    {
      menuHeader:
        market === MARKET_ON ? labels.consignment : labels.privateImport,
      menuItems: [
        {
          type: "pdfAction",
          label: labels.restaurantList,
          filters: createListingPdfFilters({
            inventory: consignmentInventory,
            tax: "OUT",
          }),
        },
        {
          type: "pdfAction",
          label: labels.individualList,
          filters: createListingPdfFilters({
            inventory: consignmentInventory,
            tax: "IN",
          }),
        },
        {
          type: "route",
          to: createProductRoute({
            inventory: [consignmentInventory],
            show: "AVAILABLE",
          }),
          label: labels.availableWines,
        },
        {
          type: "route",
          to: createProductRoute({
            inventory: [consignmentInventory],
            show: "UPCOMING",
            strictUpcoming: "1",
          }),
          label: labels.upcomingWines,
        },
      ],
    },
    {
      menuHeader: labels.products,
      menuItems: [
        {
          type: "route",
          to: createProductRoute({ type: ["VIN"] }),
          label: labels.wines,
        },
        {
          type: "route",
          to: createProductRoute({ type: ["CIDRE", "BIERE"] }),
          label: labels.ciderBeer,
        },
        {
          type: "route",
          to: createProductRoute({ type: ["SPIRITUEUX"] }),
          label: labels.spirits,
        },
        {
          type: "route",
          to: createProductRoute({ type: ["BOISSON", "EPICERIE"] }),
          label: labels.nonAlcoholic,
        },
        {
          type: "route",
          to: createProductRoute({
            inventory: [boutiqueInventory],
            show: "AVAILABLE_UPCOMING",
          }),
          label: labels.boutique,
        },
      ],
    },
    {
      menuHeader: labels.getInTouch,
      menuItems: [
        { type: "route", to: "/contact-us", label: labels.contactUs },
        { type: "route", to: "/newsletter", label: labels.newsletter },
        { type: "route", to: "/trade-contact", label: labels.becomeClient },
      ],
    },
  ];
}
